import { render } from "./IzinGuru.vue?vue&type=template&id=745fb4af"
import script from "./IzinGuru.vue?vue&type=script&lang=js"
export * from "./IzinGuru.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__